declare const __APP_CONFIG__: {
  ENV: string;
  API_BASE_URL: string;
  SUPPORT_EMAIL: string;
  DATE_PICKER?: {
    MIN_DATE?: string;
    MAX_RANGE_MONTHS?: number;
  };
};

export const environment = {
  APP_NAME: 'settlement' as const,
  PRODUCTION: __APP_CONFIG__.ENV === 'production',
  API_BASE_URL: __APP_CONFIG__.API_BASE_URL || 'https://dev.olvpay.api.silicondali.com',
  SUPPORT_EMAIL: __APP_CONFIG__.SUPPORT_EMAIL || 'support@example.com',
  DATE_PICKER: {
    MIN_DATE: __APP_CONFIG__.DATE_PICKER?.MIN_DATE || '2024-01-01',
    MAX_RANGE_MONTHS: __APP_CONFIG__.DATE_PICKER?.MAX_RANGE_MONTHS || 36,
  },
  TRONSCAN_BASE_URL: __APP_CONFIG__.ENV === 'production' ? 'https://tronscan.org' : 'https://nile.tronscan.org',
  ETHERSCAN_BASE_URL: __APP_CONFIG__.ENV === 'production' ? 'https://etherscan.io' : 'https://sepolia.etherscan.io',
  BSCSCAN_BASE_URL: __APP_CONFIG__.ENV === 'production' ? 'https://bscscan.com' : 'https://testnet.bscscan.com',
};
